/** Format a YYYY-MM-DD string as German DD.MM.YYYY without parsing into a Date. */
export function formatGermanDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : iso;
}

const WEEKDAYS = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

export function weekday(iso: string | null | undefined): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return '';
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return WEEKDAYS[d.getDay()];
}

export function relativeFromNow(iso: string | null | undefined, now: Date = new Date()): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return '';
  const then = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const diffDays = Math.floor((now.getTime() - then.getTime()) / (1000 * 60 * 60 * 24));
  if (diffDays < 0) return 'in der Zukunft';
  if (diffDays === 0) return 'heute';
  if (diffDays === 1) return 'gestern';
  if (diffDays < 7)   return `vor ${diffDays} Tagen`;
  if (diffDays < 30)  return `vor ${Math.floor(diffDays / 7)} Woche${Math.floor(diffDays / 7) === 1 ? '' : 'n'}`;
  if (diffDays < 365) return `vor ${Math.floor(diffDays / 30)} Monat${Math.floor(diffDays / 30) === 1 ? '' : 'en'}`;
  const years = Math.floor(diffDays / 365);
  return `vor ${years} Jahr${years === 1 ? '' : 'en'}`;
}
